export default status => {
  if (status === 'SUBMITTED') {
    return '#C9FFEF';
  } if (status === 'PENDING') {
    return '#FFEDCC';
  } return '#FFEDCC';
};
